import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("admin_token");
    if (!t) {
      setLoading(false);
      return;
    }
    api.get("/auth/me").then(
      (r) => {
        setAdmin(r.data);
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("admin_token", r.data.token);
    setAdmin(r.data.admin);
    return r.data.admin;
  };

  const logout = () => {
    localStorage.removeItem("admin_token");
    setAdmin(null);
    window.location.href = "/admin/login";
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
